<template>
	<c-dialog ref="dialog" width="500" height="300" @resolve="copyHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="from_user_id" ></c-input>
			<c-form-item label="源用户" required>
				<c-input name="from_user_info" disabled></c-input>
			</c-form-item>
			<c-form-item label="目标用户" required>
				<c-select name="to_user_list" async :multiple="{limit:50,linefeed:true}" @search="searchUser" ></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		computed: {
			...mapState(['userInfo']),
		},

		data() {
			  return {
          ref_client:1,
          from_user_id:0
        }
		},

		methods: {
			/************打开复制权限弹框**************/
			open(data, ref_client) {
				this.ref_client = ref_client;
				this.from_user_id = data.id;
				this.$refs.form.clear();
				if (data) {
					this.$refs.form.set({
						from_user_id: this.from_user_id,
						from_user_info: data.user_realname + ' | ' + (data.phone||'-')
					});
				}
				//填充form表单
				this.$refs.dialog.open({
					  title: ref_client==1 ? '复制手机端用户权限' : '复制电脑端用户权限'
				});
			},

			/************搜索用户*******************************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
                        exclude_user_id:this.from_user_id,  //排除源用户
						keyword:keyword
					},
					success:data => {
						//目标用户不可选当前登录人自己：复制权限给自己等同于修改自己操作权限
						resolve((data || []).filter(item => !this.userInfo || item.value != this.userInfo.id));
					}
				})
			},

			/************复制权限提交处理方法*******************************/
			copyHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: '/sys_user/user_menu_copy',
					dataFormatter: data => {
						data.ref_client = this.ref_client
						return data;
					},
					rule: {
						from_user_id: '源用户信息不能为空',
						to_user_list: '请至少选择一个目标用户'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '权限复制成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>